// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchContainer_searchContainer__2O3o4","searchIcon":"SearchContainer_searchIcon__3Rg1c","isFocused":"SearchContainer_isFocused__3rSZ8"};